import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core'
import PropTypes from 'prop-types'
import { OnChange } from 'react-final-form-listeners'
import { Form } from 'react-final-form'
import { Radios, Checkboxes, TextField } from 'mui-rff'
import QuestionHeader from './questionHeader'

const useStyles = makeStyles(() => ({
  checkbox: {
    '& .Mui-checked': {
      color: 'var(--button-color)'
    },
  },
}))

export default function RenderRadioButton({ elmIndex, elm, valIndex, valueChange, allowModify }) {
  const classes = useStyles()
  const [initialValues, setInitialValues] = useState({
    __Simplemnt_Other: ''
  })
  const name = `elm-${elmIndex}-val-${valIndex}`

  const elmValueChange = (v) => {
    const values = JSON.parse(JSON.stringify(v))
    if (!Array.isArray(values[name])) values[name] = [values[name]]
    const newVal = values[name].filter(e => e != '__Simplemnt_Other')  // Strip out the Other placeholder before saving in the DB
    if (values['__Simplemnt_Other'] && values[name].indexOf('__Simplemnt_Other') > -1) newVal.push(values['__Simplemnt_Other'])  // Push the actual value of the other into the saved array
    valueChange(elmIndex, valIndex, newVal.filter(e => !!e))
  }

  const options = elm.Options?.split(',').map(val => {
    return { label: val.trim(), value: val.trim() }
  }) ?? []

  // only update the initial values on a true state change to prevent flickering / state drift
  useEffect(() => {
    const initialValuesCopy = JSON.parse(JSON.stringify(initialValues))
    const otherFilter = val => {
      if (!val) return
      // If there is a saved value that is not in the options list
      // Add the Other placeholder to the initial values and populate the other text field with this value
      if (!options.find(e => e.value === val)) {
        initialValuesCopy['__Simplemnt_Other'] = val
        return '__Simplemnt_Other'
      }
      return val
    }
    if (!elm.Multiple) initialValuesCopy[name] = [elm.Value[valIndex] ? elm.Value[valIndex][0] : ''].map(otherFilter)[0]
    else initialValuesCopy[name] = elm.Value[valIndex]?.map(otherFilter) ?? null
    setInitialValues(initialValuesCopy)
  }, [elmIndex, elm, name, valIndex])

  return <div key={elmIndex} className={classes.checkbox}>
    <QuestionHeader helpTooltip={elm.ShowHelpTooltip ? elm.HelpTooltip : ''} prompt={elm.Prompt} allowBlanks={!!elm.AllowBlanks} />
    <Form onSubmit={() => { }}
      subscription={{ values: true }}
      initialValues={initialValues}
      render={({ values }) => {
        // Render Freeform Input
        let liveOptions = JSON.parse(JSON.stringify(options))
        if (elm.Freeform) {
          liveOptions.push({
            value: '__Simplemnt_Other',
            label: <>
              <TextField name="__Simplemnt_Other" variant="outlined" placeholder="Other" disabled={values[name]?.indexOf('__Simplemnt_Other') === -1} />
              <OnChange name="__Simplemnt_Other">
                {() => elmValueChange(values)}
              </OnChange>
            </>
          })
        }

        return <>
          {elm.Multiple ?
            <Checkboxes name={name} variant="outlined" disabled={!allowModify} data={liveOptions} />
            :
            <Radios name={name} variant="outlined" disabled={!allowModify} data={liveOptions} />
          }
          <OnChange name={name}>
            {() => elmValueChange(values)}
          </OnChange>
        </>
      }} //debug: <pre>{JSON.stringify(values, 0, 2)}</pre>
    />
  </div>
}

RenderRadioButton.propTypes = {
  elmIndex: PropTypes.number.isRequired,
  elm: PropTypes.object.isRequired,
  valIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  valueChange: PropTypes.func.isRequired,
  allowModify: PropTypes.bool.isRequired,
}